/**
 *
 * @overview 表格列表新
 * @author wuTao
 * @date 2023-04-04
 */
import React from "react";
import { component_tool, framework_tool, utils_tool } from '@/tool';
import PropTypes from "prop-types";
import {
  _buildColumns,
  _buildLookModalProps,
  _buildSideBarLookModalProps,
  _formatDeleteRecord,
  formatPage,
  reverseFormatPage,
} from "./utils";
import { handleTabelHeader } from '@/utils/handleTabelHeaderUtils';
import moment from "moment";
import "./index.less";

let { templateUtils, WizAudienceGroupItem } = framework_tool;

let {
  WizCard,
  WizAlert,
  WizSearchBar,
  WizDataTable,
  WizComponent,
  WizModalForm,
  WizButton,
  WizModal,
  WizIcon,
  WizTree,
  WizLayout,
  WizModalDescriptions,
  WizDropdown,
  WizMenu,
  WizRow,
  WizCol
} = component_tool;
let { isType, $$, Session, deepReplaceKey, isEqual } = utils_tool;
const { Pagination, Oper } = WizDataTable;
const { Sider, Content } = WizLayout;

export default class WizTableListNew extends WizComponent {
  constructor(props) {
    super(props);
    this.state = {
      record: null,
      visible: false,
      visibleTreeEntity: false,
      rows: [],
      normal: this.props.dataItems ? true : false, //模式：普通模式/动态数据模式,
      dataItems: this.props.dataItems ? this.props.dataItems : undefined,
      selectedRows: 0,
      look: false,
      showAlert: false,
      showAuthVisible: false,
      scope: {},
      params: {},
      treeEntityRecord: null,
      treeEditEntityRecord: null,
      treeSelectedKeys: [],
    };
    this.modal = {};
    this.filters = {};
    this.treeSearch = {};
    this.treeEntity = null;
    this.propsAndStateOnChange = props.needMonitor || {};
  }

  componentDidMount() {
    try { //@框架问题 重新打开页面搜索条件回显示
      if (sessionStorage.getItem('searchMap') && this.search_ref.getFieldsValue()) {
        const value = JSON.parse(sessionStorage.getItem('searchMap'));
        const form = this.search_ref.getFieldsValue();
        const key = window.location.hash;
        value.forEach(item => {
          if (item.key === key) {
            for (let _key in form) {
              if (item.value.list[_key] || item.value.list[_key] == 0) {
                form[_key] = item.value.list[_key];
              }
            }
          }
        })
        // 格式化日期选择其
        for (let key in form) {
          let val = this.search_ref.getFieldInstance(key);
          if (val && val.hasOwnProperty('picker')) {
            if (form[key]) {
              // 区间类型
              if (Object.prototype.toString.call(form[key]) === '[object Array]') {
                for (let i = 0; i < form[key].length; i++) {
                  form[key][i] = moment.isMoment(form[key][i]) ? form[key][i] : moment(form[key][i]);
                }
              } else { // 单行
                form[key] = moment.isMoment(form[key]) ? form[key] : moment(form[key]);
              }
            }
          }
        }
        this.search_ref.setFieldsValue(form);
      }
    } catch (err) {
      console.log(err)
    }
  }

  /**
   * 1\监控是否需要刷新列表
   * 2\由于获取数据与tablelist分离了，导致新增、修改完无法关闭modal，故在此监控是否要关闭modal,属于临时方法，不是好的解决方案
   * mll 2019-12-27
   */
  componentWillReceiveProps(nextProps) {
    let { _datas, params, siderBarProps } = nextProps;
    let commonOperate = {
      add: true,
      update: true,
      delete: true,
      look: true,
      sideBarAdd: true,
      sideBarAddChildren: true,
      sideBarUpdate: true,
      moveUp: true,
      moveDown: true,
    };
    let refFlag = false;
    let sideBarFlag = false;
    if (!this.commonState) {
      this.commonState = {};
      if (commonOperate) {
        Object.keys(commonOperate).forEach((key) => {
          if (_datas[key]) {
            this.commonState[key] = _datas[key];
          }
        });
      }
    } else {
      let flag = false;
      let o = {};
      Object.keys(this.commonState).forEach((key) => {
        if (_datas[key] && _datas[key]["success"] === true) {
          if (
            _datas[key]["actionCompleteTime"] &&
            this.commonState[key]["actionCompleteTime"] !==
            _datas[key]["actionCompleteTime"]
          ) {
            if (isType(siderBarProps, "Object")) {
              const { buttonSort } = siderBarProps;
              if (buttonSort && buttonSort instanceof Array && buttonSort.length > 0) {
                if ($$.isArray(buttonSort) && buttonSort.length) {
                  buttonSort.forEach((key_) => {
                    if (key === key_) {
                      sideBarFlag = true;
                    }
                  })
                }
              }
            }

            flag = true;
            o[key] = _datas[key];
          }
        }
      });
      if (flag) {
        this.commonState = { ...this.commonState, ...o };
        if (sideBarFlag) {
          if (isType(siderBarProps, "Object") && siderBarProps.searchKey) {
            const { searchKey } = siderBarProps;
            this.filters[searchKey] = null;
            this.treeSearch = {};
            this.treeEntity = null;
            this.setState({
              visible: false,
              visibleTreeEntity: false,
              treeEntityRecord: null,
              treeEditEntityRecord: null,
              treeSelectedKeys: []
            });
          } else {
            this.setState({ visible: false, visibleTreeEntity: false });
          }
        } else {
          this.setState({ visible: false, visibleTreeEntity: false });
        }
        refFlag = true;
      }
      if (refFlag) {
        this._removeSelected(() => {
          this.doOperate("list", this.filters);
          this.doOperate("treeData", { _CACHE: false });
        });
      }
    }
  }

  /**
   * 搜索栏
   */
  _searchBar = (searchBarProps, columns) => {
    let { buttons, buttonSort, ...otherProps } = searchBarProps;
    let { paging, pageFormat, openPullDown, commonOperate } = this.props;
    const { searchBarKey, params } = this.state
    let { normal } = this.state;
    let search = {
      key: searchBarKey,
      columns,
      onSearch: (values) => {
        if (!normal) {
          if (paging) {
            this.filters = reverseFormatPage(
              this.dataItems
                .filter({ ...this.treeSearch, ...values })
                .jumpPage(1, this.pageSize || 10),
              pageFormat
            );
            this._removeSelected(() => {
              this.doOperate("list", this.filters);
            });
          } else {
            this.filters = values["filters"] ? values["filters"] : {};
            this.doOperate("list", { ...values, ...this.filters });
          }
        }
      },
      cache: true,
      record: params,
      ...otherProps,
    };
    let modal = [];
    for (let key in this.modal) {
      modal.push(this.modal[key] && this.modal[key]());
    }
    return (
      <React.Fragment>
        <WizCard>
          <WizSearchBar
            type="grid"
            {...search}
            ref={(e) => (this.search_ref = e)}
          />
        </WizCard>
        {modal}
      </React.Fragment>
    )
  };

  /**
   * 新增 / 修改
   */
  _onAdd(record = null) {
    this.setState({
      record: record,
      visible: true,
      look: false,
    });
  }

  /**
   * 删除
   * @param {object | array} 表单记录, 批量删除时为数组
   */
  _onDelete(record) {
    if (!record) return;
    if ($$.isArray(record) && !record.length) return;

    // const content = `您是否要删除这${
    //   $$.isArray(record) ? record.length : ""
    //   }项？`;
    const content = "删除后数据不可恢复，您确定要删除选中的数据吗？";
    let ids = _formatDeleteRecord(record);
    WizModal.confirm({
      title: "注意",
      content,
      onOk: () => {
        this.doOperate("delete", { ...ids, _CACHE: false });
      },
      onCancel() {
      },
    });
  }

  /**
   * 构建按钮数据
   */
  _buildButtons = (btns, record) => {
    if (isType(btns, "Array")) {
      let r = [];
      btns &&
        btns.forEach((btn) => {
          r.push(
            templateUtils.getComponentByConfig(this._buildButton(btn, record))
          );
        });
      return r;
    } else {
      return [
        templateUtils.getComponentByConfig(this._buildButton(btns, record)),
      ];
    }
  };

  /**
   * 构建单按钮
   */
  _buildButton = (btn, record) => {
    let { rows } = this.state;
    let { loading, doAction, _datas } = this.props;
    let { custom, key, params, customOnClick, needSelect, textFormat } = btn;
    if (!custom) {
      let onPress = btn["onClick"];
      if (onPress && isType(onPress, "Function")) {
        params["onClick"] = () => {
          onPress && onPress({ loading, doAction, _datas, rows, record, filter: this.filters });
        };
      }
      return btn;
    } else {
      if (!key) {
        log.error("WizTableListNew: 自定义搜索栏按钮必须传入[key]! ");
        return null;
      }
      if (!params || !customOnClick) {
        return btn;
      } else {
        let disabled = false;
        if (needSelect) {
          disabled = !rows.length;
        }
        let onClick = () => {
          log.info(
            " btn [" +
            key +
            "] clicked, you need to pass in [onClick] method!  "
          );
        };
        if (customOnClick && customOnClick["key"]) {
          if (customOnClick["key"] === "modal") {
            this._buildModal(customOnClick, key, record);
          }
          onClick = () => this._btnCustomClick(customOnClick, key, record);
        }
        let btnTextParams = {};
        if (textFormat && textFormat["recordKey"] && textFormat["dirt"]) {
          let t = textFormat["dirt"][record[textFormat["recordKey"]]];
          btnTextParams = { children: t };
        }
        let otherParams =
          (btn["recordChangeParams"] &&
            btn["recordChangeParams"]({ record, rows })) ||
          {};
        return (
          <WizButton
            key={key}
            onClick={onClick}
            disabled={disabled}
            {...params}
            {...btnTextParams}
            {...otherParams}
          />
        );
      }
    }
  };

  _btnCustomClickCallBack(apiKey, apiParams, p) {
    this.doOperate(apiKey, { ...apiParams, ...p, _CACHE: false });
  }

  /**
   * 自定义按钮触发事件，
   * key为modal为modal模式，action为action模式，
   * action会从调用api中的接口，
   * formatParams的是按钮被点击时回传的参数格式化方法
   * formatParams:(rows,record,filters,callback)=>{return p}}
   * apiKey是调用api接口的kay,apiParams是默认参数，formatParams的参数会覆盖默认参数
   */
  _btnCustomClick = ({ key, params, formatParams }, btnKey, record = {}) => {
    if (key === "action") {
      // let params = {
      //     apiKey : 'demo',
      //     apiParams,
      //     formatParams:(rows,record,filters)=>{}
      // }
      this.commonState[params["apiKey"]] = {};
      let p = formatParams
        ? formatParams(this.state.rows, record, this.filters, (e) => {
          this._btnCustomClickCallBack(
            params["apiKey"],
            params["apiParams"],
            e
          );
        })
        : { ...this.state.rows, ...record, ...this.filters };
      if (p) {
        this.doOperate(params["apiKey"], { ...params["apiParams"], ...p, _CACHE: false });
      }
    } else if (key === "modal") {
      // let params = {
      //     modalKey : 'demo',
      //     modalParams:{},
      // }
      let modalKey = params["modalKey"] || btnKey;
      if (record && record["id"]) {
        modalKey = modalKey + "@" + record["id"];
      }
      this.setState({ [modalKey]: true });
    } else if (key === "jumpPage") {
      let { key, pathname } = params;
      this.props.jumpPage &&
        this.props.jumpPage(key, pathname, {
          rows: this.state.rows,
          ...params["record"],
          ...record,
        });
    }
  };

  _buildModal = ({ key, params }, btnKey, record) => {
    let modalKey = params["modalKey"] || btnKey;
    if (record && record["id"]) {
      modalKey = modalKey + "@" + record["id"];
    }
    let modalParams = params["modalParams"];
    let onOk = params["modalParams"] && params["modalParams"]["onOk"];
    let onCancel = params["modalParams"] && params["modalParams"]["onCancel"];
    if (
      modalParams &&
      modalParams["diy"] &&
      isType(modalParams["diy"], "Function")
    ) {
      let diyFun = modalParams["diy"];
      let e = {
        changeModal: (modalFlag, onRef, needClearSelect) => {
          this.setState({ [modalKey]: modalFlag });
          if (onRef) {
            if (needClearSelect) {
              this._removeSelected(() => {
                this.doOperate("list", { ...this.filters, _CACHE: false });
              })
            } else {
              this.doOperate("list", { ...this.filters, _CACHE: false });
            }
          }
        },
        parentProps: this.props,
        record: record,
        rows: this.state.rows,
      };
      //delete modalParams['diy']
      this.modal[modalKey] = () => (
        <WizModal
          {...modalParams}
          visible={this.state[modalKey]}
          onCancel={() => {
            e.changeModal(false);
            onCancel && onCancel();
          }}
          onOk={() => {
            onOk();
          }}
        >
          {diyFun && diyFun(e)}
        </WizModal>
      );
    } else {
      this.modal[modalKey] = () => (
        <WizModal
          {...modalParams}
          visible={this.state[modalKey]}
          onOk={() => {
            this.setState(
              {
                [modalKey]: false,
              },
              () => {
                onOk && onOk();
              }
            );
          }}
          onCancel={() => {
            this.setState(
              {
                [modalKey]: false,
              },
              () => {
                onCancel && onCancel();
              }
            );
          }}
        />
      );
    }
  };

  _buildAddBtn = () => {
    return (
      <WizButton
        type="primary"
        icon="plus"
        onClick={() => {
          this._onAdd();
        }}
      >
        新增
      </WizButton>
    );
  };

  _buildDeleteBtn = (rows) => {
    return (
      <WizButton
        disabled={!rows.length}
        onClick={() => this._onDelete(rows)}
        icon="delete"
        type="danger"
      >
        删除
      </WizButton>
    );
  };

  /**
   * 构建按钮组
   */
  _buildBtnGroup = (group) => {
    //格式请参考母版->wiz-frameworks -> wizTableList
    let r = [];
    let ops = group["options"];
    if (ops && ops.length) {
      let _ops = [];
      ops.forEach((o) => {
        if (this.checkAccessBtn(o["key"])) {
          _ops.push(o);
        }
      });
      if (_ops.length > 1) {
        let menuItem = [];
        _ops.forEach((ops) => {
          let { customOnClick, onClick, params } = ops;
          let _onClick = onClick;
          if (customOnClick && customOnClick["key"]) {
            if (customOnClick["key"] === "modal") {
              this._buildModal(customOnClick, ops["key"]);
            }
            _onClick = () => this._btnCustomClick(customOnClick, ops["key"]);
          }
          menuItem.push(
            <WizMenu.Item key={ops["key"]} {...params} onClick={_onClick} />
          );
        });
        r.push(
          <WizDropdown overlay={<WizMenu>{menuItem}</WizMenu>}>
            <WizButton {...group["params"]} />
          </WizDropdown>
        );
      } else if (_ops.length === 1) {
        r.push(...this._buildButtons(_ops));
      }
    }
    return r;
  };

  /**
   * 搜索操作按钮
   */
  _buildOperationButton = (buttons = [], sort = []) => {
    let { rows } = this.state;
    let btns = [];
    if (sort.length > 0 && buttons.length > 0) {
      sort.forEach((key) => {
        let flag = false;
        if (key === "add" || key === "delete") {
          flag = true;
        }
        buttons.forEach((btn) => {
          if (btn["type"] === "group" && key === btn["key"]) {
            btns.push(...this._buildBtnGroup(btn));
          } else if (this.checkAccessBtn(key) && key === btn["key"]) {
            if (key === "add" || key === "delete") {
              flag = false;
            }
            btns.push(...this._buildButtons([btn]));
          }
        });
        if (flag) {
          if (this.checkAccessBtn(key) && key === "add") {
            btns.push(this._buildAddBtn());
          } else if (this.checkAccessBtn(key) && key === "delete") {
            btns.push(this._buildDeleteBtn(rows));
          }
        }
      });
    } else if (sort.length > 0) {
      sort.forEach((key) => {
        if (this.checkAccessBtn(key) && key === "add") {
          btns.push(this._buildAddBtn());
        } else if (this.checkAccessBtn(key) && key === "delete") {
          btns.push(this._buildDeleteBtn(rows));
        }
      });
    }
    return <div className="btns-toolbar-group">{btns}</div>;
  };


  /**
   * 树操作按钮
   */
  _buildSideBarOperationButton = (buttons = [], sort = []) => {
    // this.treeEntity;
    let { treeEntityRecord, record } = this.state;
    let btns = [];
    if (sort && sort.length > 0 && buttons && buttons.length > 0) {
      sort.forEach((key) => {
        let flag = false;
        if (key === "sideBarAdd" || key === "sideBarAddChildren" || key === "sideBarUpdate" || key === "moveUp"
          || key === "moveDown" || key === "sideBarDelete") {
          flag = true;
        }
        buttons.forEach((btn) => {
          if (btn["type"] === "group" && key === btn["key"]) {
            btns.push(...this._buildSideBarBtnGroup(btn));
          } else if (this.checkAccessBtn(key) && key === btn["key"]) {
            if (key === "sideBarAdd" || key === "sideBarAddChildren" || key === "sideBarUpdate" || key === "moveUp"
              || key === "moveDown" || key === "sideBarDelete") {
              flag = false;
            }
            btns.push(...this._buildSideBarButtons([btn], record, treeEntityRecord));
          }
        });
        if (flag) {
          if (this.checkAccessBtn(key) && key === "sideBarAdd") {
            btns.push(this._buildSideBarAddBtn());
          } else if (this.checkAccessBtn(key) && key === "sideBarAddChildren") {
            btns.push(this._buildSideBarAddChildrenBtn());
          } else if (this.checkAccessBtn(key) && key === "sideBarUpdate") {
            btns.push(this._buildSideBarUpdateBtn());
          } else if (this.checkAccessBtn(key) && key === "sideBarDelete") {
            btns.push(this._buildSideBarDeleteBtn());
          } else if (this.checkAccessBtn(key) && key === "moveUp") {
            btns.push(this._buildSideBarMoveUpBtn());
          } else if (this.checkAccessBtn(key) && key === "moveDown") {
            btns.push(this._buildSideBarMoveDownBtn());
          }
        }
      });
    } else if (sort && sort.length > 0) {
      sort.forEach((key) => {
        if (this.checkAccessBtn(key) && key === "sideBarAdd") {
          btns.push(this._buildSideBarAddBtn());
        } else if (this.checkAccessBtn(key) && key === "sideBarAddChildren") {
          btns.push(this._buildSideBarAddChildrenBtn());
        } else if (this.checkAccessBtn(key) && key === "sideBarUpdate") {
          btns.push(this._buildSideBarUpdateBtn());
        } else if (this.checkAccessBtn(key) && key === "sideBarDelete") {
          btns.push(this._buildSideBarDeleteBtn());
        } else if (this.checkAccessBtn(key) && key === "moveUp") {
          btns.push(this._buildSideBarMoveUpBtn());
        } else if (this.checkAccessBtn(key) && key === "moveDown") {
          btns.push(this._buildSideBarMoveDownBtn());
        }
      });
    }
    return <div className="btns-toolSidebar-group">{btns}</div>;
  };


  /**
   * 构建按钮组
   */
  _buildSideBarBtnGroup = (group) => {
    //格式请参考母版->wiz-frameworks -> wizTableList
    let { treeEntityRecord, record } = this.state;
    let r = [];
    let ops = group["options"];
    if (ops && ops.length) {
      let _ops = [];
      ops.forEach((o) => {
        if (this.checkAccessBtn(o["key"])) {
          _ops.push(o);
        }
      });
      if (_ops.length > 1) {
        let menuItem = [];
        _ops.forEach((ops) => {
          let { customOnClick, onClick, params } = ops;
          let _onClick = onClick;
          if (customOnClick && customOnClick["key"]) {
            if (customOnClick["key"] === "modal") {
              this._buildSideBarModal(customOnClick, ops["key"], record, treeEntityRecord);
            }
            _onClick = () => this._btnSideBarCustomClick(customOnClick, ops["key"], record, treeEntityRecord);
          }
          menuItem.push(
            <WizMenu.Item key={ops["key"]} {...params} onClick={_onClick} />
          );
        });
        r.push(
          <WizDropdown overlay={<WizMenu>{menuItem}</WizMenu>}>
            <WizButton {...group["params"]} />
          </WizDropdown>
        );
      } else if (_ops.length === 1) {
        r.push(...this._buildSideBarButtons(_ops, record, treeEntityRecord));
      }
    }
    return r;
  };

  /**
   * 构建按钮数据
   */
  _buildSideBarButtons = (btns, record, treeEntityRecord) => {
    if (isType(btns, "Array")) {
      let r = [];
      btns &&
        btns.forEach((btn) => {
          r.push(
            templateUtils.getComponentByConfig(this._buildSideBarButton(btn, record, treeEntityRecord))
          );
        });
      return r;
    } else {
      return [
        templateUtils.getComponentByConfig(this._buildSideBarButton(btns, record, treeEntityRecord)),
      ];
    }
  };


  /**
   * 构建单按钮
   */
  _buildSideBarButton = (btn, record, treeEntityRecord) => {
    let { rows } = this.state;
    let { loading, doAction, _datas } = this.props;
    let { custom, key, params, customOnClick, needSelect, textFormat } = btn;
    if (!custom) {
      let onPress = btn["onClick"];
      if (onPress && isType(onPress, "Function")) {
        params["onClick"] = () => {
          onPress && onPress({ loading, doAction, _datas, rows, record, filter: this.filters, treeEntityRecord });
        };
      }
      return btn;
    } else {
      if (!key) {
        log.error("WizTableListNew: 自定义搜索栏按钮必须传入[key]! ");
        return null;
      }
      if (!params || !customOnClick) {
        return btn;
      } else {
        let disabled = false;
        if (needSelect) {
          disabled = !rows.length;
        }
        let onClick = () => {
          log.info(
            " btn [" +
            key +
            "] clicked, you need to pass in [onClick] method!  "
          );
        };
        if (customOnClick && customOnClick["key"]) {
          if (customOnClick["key"] === "modal") {
            this._buildSideBarModal(customOnClick, key, record, treeEntityRecord);
          }
          onClick = () => this._btnSideBarCustomClick(customOnClick, key, record, treeEntityRecord);
        }
        let btnTextParams = {};
        if (textFormat && textFormat["recordKey"] && textFormat["dirt"]) {
          let t = textFormat["dirt"][record[textFormat["recordKey"]]];
          btnTextParams = { children: t };
        }
        let otherParams =
          (btn["recordChangeParams"] &&
            btn["recordChangeParams"]({ record, rows, treeEntityRecord })) ||
          {};
        if (params && params.icon) {
          return (
            <WizButton
              key={key}
              onClick={onClick}
              disabled={disabled}
              {...params}
              {...btnTextParams}
              {...otherParams}
              icon={null}
            >
              <WizIcon type={params.icon}
                style={{ fontSize: '30px' }} />
            </WizButton>
          );
        } else {
          return (
            <WizButton
              key={key}
              onClick={onClick}
              disabled={disabled}
              {...params}
              {...btnTextParams}
              {...otherParams}
            />
          );
        }
      }
    }
  };


  /**
   * 自定义按钮触发事件，
   * key为modal为modal模式，action为action模式，
   * action会从调用api中的接口，
   * formatParams的是按钮被点击时回传的参数格式化方法
   * formatParams:(rows,record,filters,callback)=>{return p}}
   * apiKey是调用api接口的kay,apiParams是默认参数，formatParams的参数会覆盖默认参数
   */
  _btnSideBarCustomClick = ({ key, params, formatParams }, btnKey, record = {}, treeEntityRecord = {}) => {
    if (key === "action") {
      this.commonState[params["apiKey"]] = {};
      let p = formatParams
        ? formatParams(this.state.rows, record, this.filters, treeEntityRecord, (e) => {
          this._btnCustomClickCallBack(
            params["apiKey"],
            params["apiParams"],
            e
          );
        })
        : { ...this.state.rows, ...treeEntityRecord, ...this.filters };
      if (p) {
        this.doOperate(params["apiKey"], { ...params["apiParams"], ...p, _CACHE: false });
      }
    } else if (key === "modal") {
      // let params = {
      //     modalKey : 'demo',
      //     modalParams:{},
      // }
      let modalKey = params["modalKey"] || btnKey;
      if (record && record["id"]) {
        modalKey = modalKey + "@" + treeEntityRecord["id"];
      }
      this.setState({ [modalKey]: true });
    } else if (key === "jumpPage") {
      let { key, pathname } = params;
      this.props.jumpPage &&
        this.props.jumpPage(key, pathname, {
          rows: this.state.rows,
          ...params["treeEntityRecord"],
          record: record,
          ...treeEntityRecord,
        });
    }
  };

  _buildSideBarModal = ({ key, params }, btnKey, record, treeEntityRecord) => {
    let modalKey = params["modalKey"] || btnKey;
    if (treeEntityRecord && treeEntityRecord["id"]) {
      modalKey = modalKey + "@" + treeEntityRecord["id"];
    }
    let modalParams = params["modalParams"];
    let onOk = params["modalParams"] && params["modalParams"]["onOk"];
    let onCancel = params["modalParams"] && params["modalParams"]["onCancel"];
    if (
      modalParams &&
      modalParams["diy"] &&
      isType(modalParams["diy"], "Function")
    ) {
      let diyFun = modalParams["diy"];
      let e = {
        changeModal: (modalFlag, onRef, needClearSelect) => {
          this.setState({ [modalKey]: modalFlag });
          if (onRef) {
            if (needClearSelect) {
              this._removeSelected(() => {
                this.doOperate("list", { ...this.filters, _CACHE: false });
              })
            } else {
              this.doOperate("list", { ...this.filters, _CACHE: false });
            }
          }
        },
        parentProps: this.props,
        record: treeEntityRecord,
        rows: this.state.rows,
      };
      //delete modalParams['diy']
      this.modal[modalKey] = () => (
        <WizModal
          {...modalParams}
          visible={this.state[modalKey]}
          onCancel={() => {
            e.changeModal(false);
            onCancel && onCancel();
          }}
          onOk={() => {
            onOk();
          }}
        >
          {diyFun && diyFun(e)}
        </WizModal>
      );
    } else {
      this.modal[modalKey] = () => (
        <WizModal
          {...modalParams}
          visible={this.state[modalKey]}
          onOk={() => {
            this.setState(
              {
                [modalKey]: false,
              },
              () => {
                onOk && onOk();
              }
            );
          }}
          onCancel={() => {
            this.setState(
              {
                [modalKey]: false,
              },
              () => {
                onCancel && onCancel();
              }
            );
          }}
        />
      );
    }
  };

  /**
   * 向上移动节点
   * @returns {JSX.Element}
   * @private
   */
  _buildSideBarMoveUpBtn = () => {
    let { treeEntityRecord } = this.state;
    let tooltip = "上移";
    if (!treeEntityRecord) {
      tooltip = "请先点击选中需要调整顺序的分类"
    }
    return (
      <WizButton
        disabled={!treeEntityRecord}
        type={"link"}
        shape={"circle"}
        tooltip={tooltip}
        onClick={() => this._onSideBarSort(treeEntityRecord, "moveUp")}
      >
        <img className="btn-icon" src={require("assets/images/sideBar/icon/向上.png")} alt="" />
      </WizButton>
    );
  };


  /**
   * 向上移动节点
   * @returns {JSX.Element}
   * @private
   */
  _buildSideBarMoveDownBtn = () => {
    let { treeEntityRecord } = this.state;
    let tooltip = "下移";
    if (!treeEntityRecord) {
      tooltip = "请先点击选中需要调整顺序的分类"
    }
    return (
      <WizButton
        disabled={!treeEntityRecord}
        type={"link"}
        shape={"circle"}
        tooltip={tooltip}
        onClick={() => this._onSideBarSort(treeEntityRecord, "moveDown")}
      >
        <img className="btn-icon" src={require("assets/images/sideBar/icon/向下.png")} alt="" />
      </WizButton>
    );
  };

  /**
   * 新增顶级节点
   * @returns {JSX.Element}
   * @private
   */
  _buildSideBarAddBtn = () => {
    let { treeEntityRecord } = this.state;
    return (
      <WizButton
        type={"link"}
        shape={"circle"}
        tooltip={"新增"}
        onClick={() => {
          this._onSideBarSave({ parentId: treeEntityRecord && treeEntityRecord.parentId, state: 1 });
        }}
      >
        <img className="btn-icon" src={require("assets/images/sideBar/icon/新增.png")} alt="" />
      </WizButton>
    );
  };

  /**
   * 新增子节点
   *
   * @returns {JSX.Element}
   * @private
   */
  _buildSideBarAddChildrenBtn = () => {
    let { treeEntityRecord } = this.state;
    let tooltip = "新增子节点";
    if (!treeEntityRecord) {
      tooltip = "请点击选中需要新增子分类的分类"
    }
    return (
      <WizButton
        disabled={!treeEntityRecord}
        type={"link"}
        tooltip={tooltip}
        shape={"circle"}
        style={{ color: "#1890ff" }}
        onClick={() => {
          this._onSideBarSave({ parentId: treeEntityRecord.id, state: 1 });
        }}
      >
        <img className="btn-icon" src={require("assets/images/sideBar/icon/新增2.png")} alt="" />
      </WizButton>
    );
  };

  /**
   * 编辑节点
   *
   * @returns {JSX.Element}
   * @private
   */
  _buildSideBarUpdateBtn = () => {
    let { treeEntityRecord } = this.state;
    let tooltip = "编辑节点";
    if (!treeEntityRecord) {
      tooltip = "请点击选中需要编辑的分类"
    }
    return (
      <WizButton
        disabled={!treeEntityRecord}
        type={"link"}
        tooltip={tooltip}
        shape={"circle"}
        style={{ color: "#1890ff" }}
        onClick={() => {
          this._onSideBarSave(treeEntityRecord);
        }}
      >
        <img className="btn-icon" src={require("assets/images/sideBar/icon/编辑.png")} alt="" />
      </WizButton>
    );
  };


  /**
   * 新增 / 修改
   */
  _onSideBarSave(treeEntityRecord = null) {
    this.setState({
      treeEditEntityRecord: treeEntityRecord,
      visibleTreeEntity: true,
      look: false,
    });
  }

  _buildSideBarDeleteBtn = () => {
    let { treeEntityRecord } = this.state;
    return (
      <WizButton
        disabled={!treeEntityRecord}
        onClick={() => this._onSideBarDelete(treeEntityRecord)}
        type={"link"}
        shape={"circle"}
        tooltip={"删除"}
      >
        <WizIcon type="delete"
          style={{ fontSize: '30px', color: "#1890ff" }} />
      </WizButton>
    );
  };

  /**
   * 排序
   * @param {object | array} 排序
   */
  _onSideBarSort(treeEntityRecord, key) {
    let msg = "上移";
    if (key === 'moveDown') {
      msg = "下移";
    }
    if (!treeEntityRecord || !treeEntityRecord.id) return;
    const content = "您确定要" + msg + "选中的数据吗？";
    let id = treeEntityRecord.id;
    //需求确认 不需要确认按钮
    this.doOperate(key, { id, _CACHE: false });
    // WizModal.confirm({
    //   title: "注意",
    //   content,
    //   onOk: () => {
    //     this.doOperate(key, {id, _CACHE: false});
    //   },
    //   onCancel() {
    //   },
    // });
  }

  /**
   * 删除
   * @param {object | array} 表单记录, 批量删除时为数组
   */
  _onSideBarDelete(treeEntityRecord) {
    let deleteRecords = [];
    deleteRecords.push(treeEntityRecord);
    let ids_ = _formatDeleteRecord(deleteRecords);
    if (!treeEntityRecord) return;
    if ($$.isArray(deleteRecords) && !deleteRecords.length) return;
    const content = "删除后数据不可恢复，您确定要删除选中的数据吗？";
    let ids = _formatDeleteRecord(deleteRecords);
    WizModal.confirm({
      title: "注意",
      content,
      onOk: () => {
        this.doOperate("sideBarDelete", { ...ids, _CACHE: false });
      },
      onCancel() {
      },
    });
  }

  /**
   * 校验按钮权限
   */
  checkAccessBtn = (key) => {
    let flag = false;
    let { accessBtns, btnAccessCheck } = this.props;
    if (!btnAccessCheck) {
      flag = true;
    } else if (accessBtns && accessBtns.length > 0) {
      accessBtns.forEach((btn) => {
        if (btn["code"] === key) {
          flag = true;
        }
      });
    }
    return flag;
  };

  showAuthModal = (e, text = {}) => {
    e.stopPropagation()
    this.setState({ showAuthVisible: true, scope: text });
  };

  /**
   * 受众列是否显示
   */
  _handleShowAuth = (columns, showAuth) => {
    const _columns = [];
    if (typeof showAuth === 'boolean') {
      _columns.push({
        title: "受众",
        tableItem: {
          width: 85,
          render: (text, record) => (
            <a onClick={(e) => this.showAuthModal(e, text.authData)}>查看受众</a>
          )
        },
      })
    } else if (Object.prototype.toString.call(showAuth) === '[object Object]') {
      _columns.push({
        title: showAuth.title || "受众",
        tableItem: {
          width: 85,
          render: (text, record) => (
            <a onClick={(e) => this.showAuthModal(e, text)}>{showAuth.text || '查看受众'}</a>
          ),
          ...showAuth
        },
      })
    } else if (Array.isArray(showAuth)) {
      try {
        const items = showAuth.map(val => ({
          title: val.title,
          tableItem: {
            width: 85,
            render: (text, record) => (
              <a onClick={(e) => this.showAuthModal(e, text)}>{val.text || '查看受众'}</a>
            ),
            ...val
          }
        }))
        _columns.push(...items)
      } catch (error) {
        console.warn('showAuth is an illegal array of objects')
      }
    } else {
      console.warn('showAuth is an illegal parameter')
    }
    return columns.concat(_columns)
  }

  /**
   * 处理数据行操作区域
   */
  _handleOper = (
    columns,
    rowOperateView,
    dataTableProps,
    rowOperateProps = {}
  ) => {
    let { rowOperateSort } = this.props;
    let _rowOperateProps = { witdh: 200, fixed: 'right', ...rowOperateProps }
    let _columns = columns;
    if (
      (rowOperateSort && rowOperateSort.length > 0) ||
      (rowOperateView && rowOperateView.length > 0)
    ) {
      _columns.push({
        title: "操作",
        tableItem: {
          width: 220,
          ..._rowOperateProps,
          render: (text, record) => (
            <Oper maxNum={dataTableProps["maxNum"] || 3}>
              {this._buildOperBtns(text, record, rowOperateView)}
            </Oper>
          ),
        },
      });
    }
    return _columns;
  };

  _buildLookBtn = (record) => {
    return (
      <WizButton
        //tooltip="查看"
        key="look"
        onClick={(e) => {
          this.setState({
            record,
            visible: true,
            look: true,
          });
        }}
      >
        查看
      </WizButton>
    );
  };

  _buildUpdateBtn = (record) => {
    return (
      <WizButton
        //tooltip="编辑"
        key="update"
        onClick={(e) =>
          this.setState({
            record,
            visible: true,
            look: false,
          })
        }
      >
        编辑
      </WizButton>
    );
  };

  /**
   * 构建行操作按钮
   */
  _buildOperBtns = (text, record, rowOperateView = []) => {
    let { rowOperateSort } = this.props;
    let operList = [];
    if (rowOperateSort.length > 0 && rowOperateView.length > 0) {
      rowOperateSort.forEach((key) => {
        let flag = false;
        if (key === "look" || key === "update") {
          flag = true;
        }
        rowOperateView.forEach((btn) => {
          if (this.checkAccessBtn(key) && key === btn["key"]) {
            if (key === "look" || key === "update") {
              flag = false;
            }
            operList.push(...this._buildButtons([btn], record));
          }
        });
        if (flag) {
          if (this.checkAccessBtn(key) && key === "look") {
            operList.push(this._buildLookBtn(record));
          } else if (this.checkAccessBtn(key) && key === "update") {
            operList.push(this._buildUpdateBtn(record));
          }
        }
      });
    } else if (rowOperateSort.length > 0) {
      rowOperateSort.forEach((key) => {
        if (this.checkAccessBtn(key) && key === "look") {
          operList.push(this._buildLookBtn(record));
        } else if (this.checkAccessBtn(key) && key === "update") {
          operList.push(this._buildUpdateBtn(record));
        }
      });
    }
    return operList;
  };

  /**
   * 清空
   */
  _removeSelected(callback) {
    this.setState({ rows: [], selectedRows: 0 }, () => {
      callback && callback();
    });
  }

  _getDataItems() {
    let { dataItems, _datas, paging, pageFormat } = this.props;
    let _dataItems = this.state.dataItems || dataItems;

    if (!this.state.normal) {
      //动态数据模式
      _dataItems = _datas && _datas["list"] && _datas["list"]["data"];
    }
    if (!_dataItems) {
      _dataItems = {};
    } else {
      // _dataItems = _datas["list"]["data"]
    }
    if (paging) {
      _dataItems = formatPage(_dataItems, pageFormat);
    }
    return _dataItems;
  }

  _dataTable(dataTableProps = {}, columns) {
    let {
      loading,
      paging,
      pageFormat,
      rowOperateView,
      searchBarProps,
      rowOperateProps,
      rowOperateRight,
      showAuth,
    } = this.props;
    let { diy, diyMode } = dataTableProps
    let Diy = diyMode
    if (!this.pageSize && dataTableProps && dataTableProps['pageSize']) {
      this.pageSize = dataTableProps['pageSize']
    }
    let { buttons, buttonSort } = searchBarProps;
    let { rows, normal, selectedRows, showAlert } = this.state;
    let _columns = columns;
    let dataItems = this.dataItems || "";
    if (dataItems && dataItems["headList"]) {
      _columns = handleTabelHeader(dataItems["headList"]);
    }
    if (showAuth && _columns.length > 0) {
      _columns = this._handleShowAuth(_columns, showAuth);
    }
    if (rowOperateView && _columns.length > 0) {
      _columns = this._handleOper(
        _columns,
        rowOperateView,
        dataTableProps,
        rowOperateProps
      );
    }
    if (dataTableProps.selectType === "checkbox") {
      this.setState({
        showAlert: true,
      });
    }
    let _onSelect = (keys, rows) => {
      this.setState(
        {
          rows,
          data: new Date().getTime(),
          selectedRows: rows.length,
        },
        () => {
          dataTableProps["onSelect"] && dataTableProps["onSelect"](keys, rows);
        }
      );
    };
    const dataTable = {
      loading,
      columns: _columns,
      dataItems,
      bordered: false,
      size: "middle",
      selectedRowKeys: rows.map((item) => item.rowKey),
      onChange: ({ pageNum, pageSize }) => {
        if (paging) {
          this.pageSize = pageSize
          if (normal) {
            // this.setState({
            //     dataItems: dataItems.jumpPage(pageNum, pageSize)
            // })
          } else {
            this.filters = {
              ...this.filters,
              ...reverseFormatPage(
                dataItems.jumpPage(pageNum, pageSize),
                pageFormat
              ),
            };
            this._removeSelected(() => {
              this.doOperate("list", this.filters);
            });
          }
        }
      },
      ...dataTableProps,
      onSelect: _onSelect,
    };

    const message = (
      <React.Fragment>
        已选择 {selectedRows} 项
        <WizButton
          style={{ height: 20 }}
          type="link"
          //tooltip="清空"
          onClick={() => this._removeSelected()}
        >
          {" "}
          清空
        </WizButton>
      </React.Fragment>
    );
    let table = [<WizDataTable {...dataTable} />, paging ? (
      <div style={{ marginTop: 35, textAlign: "center" }}>
        <Pagination {...dataTable} />
      </div>
    ) : null]
    let r = [
      <WizCard style={{ minHeight: 570 }}>
        <WizRow align={'middle'}>
          <WizCol span={rowOperateRight ? 16 : 24}>{this._buildOperationButton(buttons, buttonSort)}</WizCol>
          {rowOperateRight ? <WizCol span={8}>{rowOperateRight()}</WizCol> : null}
        </WizRow>
        {showAlert ? (
          <WizAlert
            type="info"
            message={message}
            showIcon
            style={{ marginBottom: 15 }}
          />
        ) : null}
        {diy ? <Diy {...dataTable} table={table} /> : table}
      </WizCard>,
    ];
    return r;
  }

  /**
   * 操作
   */
  doOperate = (key, values, callback) => {
    let { operate, doAction } = this.props;
    if (operate && operate[key]) {
      operate[key](values, callback);
    } else if (doAction) {
      doAction(key, values, callback);
    } else {
      log.error(
        "WizTableListNew: 未找到 " +
        key +
        " 方法,请通过operate传入 或 传入doAction "
      );
    }
  };

  /**
   * modalForm
   * @param {*} modalFormSideBarProps_
   */
  _modalSideBarForm(modalFormSideBarProps_, columns) {
    let { loading } = this.props;
    let { record, treeEntityRecord, visibleTreeEntity, treeEditEntityRecord, look } = this.state;
    let modalFrom = {
      title: treeEditEntityRecord && treeEditEntityRecord.id ? "编辑" : treeEditEntityRecord ? "新增" : "新增",
      loading,
      record: treeEditEntityRecord,
      visible: visibleTreeEntity,
      columns,
      modalOpts: {
        width: 700,
      },
      onCancel: () => {
        this.setState({
          visibleTreeEntity: false,
        });
      },
      onSubmit: (values) => {
        let key = treeEditEntityRecord && treeEditEntityRecord.id ? "sideBarUpdate" : treeEditEntityRecord ? "sideBarAddChildren" : "sideBarAdd";
        let dataFormat = modalFormSideBarProps_["dataFormat"];
        let _values = dataFormat ? dataFormat(values) : values;
        this.doOperate(key, _values, () => {
          this.setState({
            treeEntityRecord: null,
            visibleTreeEntity: false,
            treeSelectedKeys: [],
          });
        });
      },
      ...modalFormSideBarProps_,
    };
    //查看数据构建
    if (look) {
      modalFrom = _buildSideBarLookModalProps(modalFrom, this);
      modalFrom.title = "查看";
      // return <WizModalDescriptions title="详情" {...modalFrom} />;
    }
    return <WizModalForm {...modalFrom} />;
  }


  /**
   * modalForm
   * @param {*} modalFormProps
   */
  _modalForm(modalFormProps, columns) {
    let { loading } = this.props;
    let { record, visible, look } = this.state;
    let modalFrom = {
      loading,
      record,
      visible,
      columns,
      modalOpts: {
        width: 700,
      },
      onCancel: () => {
        this.setState({
          record: null,
          visible: false,
        });
      },
      onSubmit: (values) => {
        let key = record ? "update" : "add";
        let dataFormat = modalFormProps["dataFormat"];
        let _values = dataFormat ? dataFormat(values) : values;
        this.doOperate(key, _values, () => {
          this.setState({
            record: null,
            visible: false,
          });
        });
      },
      ...modalFormProps,
    };
    //查看数据构建
    if (look) {
      modalFrom = _buildLookModalProps(modalFrom, this);
      modalFrom.title = "查看";
      // return <WizModalDescriptions title="详情" {...modalFrom} />;
    }
    return <WizModalForm {...modalFrom} />;
  }

  _sideBar(sideBarProps) {
    const { _datas, loading, pageFormat, rowOperateRight } = this.props;
    const { key, onSelect, searchKey, otherProps, buttons, buttonSort, treeEntityKey, treeEntityRowKey } = sideBarProps;
    const treeData = deepReplaceKey(_datas["treeData"]["data"], [
      { key: "key", value: "key" },
    ]);
    const treeProps = {
      key,
      treeData: treeData,
      onSelect: (selectedKeys, { selected, selectedNodes, node, event }) => {
        this.setState({ treeSelectedKeys: selectedKeys });
        if (onSelect) {
          onSelect(selectedKeys, { selected, selectedNodes, node, event });
        } else if (searchKey) {
          if (
            this.treeSearch[searchKey] &&
            this.treeSearch[searchKey] === node.props.value &&
            !selected
          ) {
            this.treeSearch = {};
            if (treeEntityKey) {
              this.treeEntity = null;
              this.setState({
                treeEntityRecord: null
              });
            }
          } else {
            this.treeSearch = { [searchKey]: node.props.value };
            if (treeEntityKey && node.props[treeEntityKey]) {
              let entity = node.props[treeEntityKey];
              let rowKey;
              if (treeEntityRowKey) {
                rowKey = entity[treeEntityRowKey];
              } else {
                rowKey = entity.id;
              }
              this.treeEntity = { ...entity, rowKey };
              this.setState({
                treeEntityRecord: { ...entity, rowKey }
              });
            }
          }
          this.filters = reverseFormatPage(
            this.dataItems.filter(this.treeSearch).jumpPage(1, this.pageSize || 10),
            pageFormat
          );
          //重置表单 哈哈
          this.search_ref.resetFields && this.search_ref.resetFields();
          this._removeSelected(() => {
            this.doOperate("list", { ...this.filters, _CACHECLEAR: true });
          });
        }
      },
      ...otherProps,
    };
    return (
      <WizCard className="tablelist-sidebar-wrp">
        <WizRow type="flex" align={'middle'} justify={'center'}>
          <WizCol span={rowOperateRight ? 8 : 24}>{this._buildSideBarOperationButton(buttons, buttonSort)}</WizCol>
          {rowOperateRight ? <WizCol span={8}>{rowOperateRight()}</WizCol> : null}
        </WizRow>
        <WizTree {...treeProps} selectedKeys={this.state.treeSelectedKeys} />
      </WizCard>
    );
  }


  /**
   * 校验按钮组是否有按钮
   */
  _checkBtnGroup = (group) => {
    let result = false;
    let ops = group["options"];
    if (ops && ops.length) {
      let _ops = [];
      ops.forEach((o) => {
        if (this.checkAccessBtn(o["key"])) {
          result = true;
        }
      });
    }
    return result;
  };

  render() {
    this.dataItems = this._getDataItems();
    const {
      searchBarProps,
      dataTableProps,
      modalFormProps,
      siderBarProps,
      columns,
      _datas,
      showAuth,
    } = this.props;
    let _columns = _buildColumns(columns, _datas);

    const { scope, showAuthVisible } = this.state

    const modalProps = {
      title: '查看受众',
      visible: showAuthVisible,
      footer: null,
      onCancel: () => {
        this.setState({ showAuthVisible: false })
      }
    }
    let buttonCount = 0;
    let width = null;
    let modalFormSideBarProps_;
    if (isType(siderBarProps, "Object")) {
      const { buttons, buttonSort, modalFormSideBarProps } = siderBarProps;
      if (isType(modalFormSideBarProps, "Object")) {
        modalFormSideBarProps_ = { ...modalFormSideBarProps };
      }
      if (buttonSort && buttonSort.length > 0) {
        if (buttons && buttons.length > 0) {
          buttonSort.forEach((key) => {
            let flag = false;
            if (key === "sideBarAdd" || key === "sideBarAddChildren" || key === "sideBarUpdate" || key === "moveUp"
              || key === "moveDown" || key === "sideBarDelete") {
              flag = true;
            }
            buttons.forEach((btn) => {
              if (btn["type"] === "group" && key === btn["key"]) {
                if (this._checkBtnGroup(btn)) {
                  buttonCount++;
                }
              } else if (this.checkAccessBtn(key) && key === btn["key"]) {
                if (key === "sideBarAdd" || key === "sideBarAddChildren" || key === "sideBarUpdate" || key === "moveUp"
                  || key === "moveDown" || key === "sideBarDelete") {
                  flag = false;
                }
                buttonCount++;
              }
            });
            if (flag) {
              if (this.checkAccessBtn(key) && key === "sideBarAdd") {
                buttonCount++;
              } else if (this.checkAccessBtn(key) && key === "sideBarAddChildren") {
                buttonCount++;
              } else if (this.checkAccessBtn(key) && key === "sideBarUpdate") {
                buttonCount++;
              } else if (this.checkAccessBtn(key) && key === "sideBarDelete") {
                buttonCount++;
              } else if (this.checkAccessBtn(key) && key === "moveUp") {
                buttonCount++;
              } else if (this.checkAccessBtn(key) && key === "moveDown") {
                buttonCount++;
              }
            }
          });
        } else {
          buttonSort.forEach((key) => {
            if (this.checkAccessBtn(key) && key === "sideBarAdd") {
              buttonCount++;
            } else if (this.checkAccessBtn(key) && key === "sideBarAddChildren") {
              buttonCount++;
            } else if (this.checkAccessBtn(key) && key === "sideBarUpdate") {
              buttonCount++;
            } else if (this.checkAccessBtn(key) && key === "sideBarDelete") {
              buttonCount++;
            } else if (this.checkAccessBtn(key) && key === "moveUp") {
              buttonCount++;
            } else if (this.checkAccessBtn(key) && key === "moveDown") {
              buttonCount++;
            }
          });
        }
        width = buttonCount > 0 ? 280 : 200;
      }
    }
    return (
      <WizLayout key={'WizLayout'}>
        {isType(siderBarProps, "Object") ? (
          <Sider key={'Side'}
            theme="light"
            width={width && width}
            style={{
              marginRight: 15,
              minHeight: "calc(100vh - 132px)",
              overflow: "auto",
            }}
          >
            {this._sideBar(siderBarProps, _columns)}
          </Sider>
        ) : null}
        <Content key={'Content'}>
          {isType(searchBarProps, "Object")
            ? this._searchBar(searchBarProps, _columns)
            : null}
          {isType(dataTableProps, "Object")
            ? this._dataTable(dataTableProps, _columns)
            : null}
          {isType(modalFormProps, "Object")
            ? this._modalForm(modalFormProps, _columns)
            : null}
          {isType(modalFormSideBarProps_, "Object")
            ? this._modalSideBarForm(modalFormSideBarProps_, _columns)
            : null}
          {showAuth ? (
            <WizModal {...modalProps}>
              <WizAudienceGroupItem {...scope} />
            </WizModal>
          ) : null}
        </Content>
      </WizLayout>
    );
  }
}

WizTableListNew.propTypes = {
  /**
   * 分页，默认true
   */
  paging: PropTypes.bool,

  /**
   * 分页格式化工具
   */
  pageFormat: PropTypes.object,

  /**
   * 数据格式 配置
   */
  columns: PropTypes.array.isRequired,
  /**
   * 表格的数据
   */
  dataItems: PropTypes.array,
  /**
   * 搜索属性
   */
  searchBarProps: PropTypes.object,

  /**
   * 数据列表属性
   */
  dataTableProps: PropTypes.object, //.isRequired,

  /**
   * modal属性
   */
  modalFormProps: PropTypes.object,
  /**
   * 侧边栏属性
   */
  siderBarProps: PropTypes.object,
  /**
   * 操作方法
   * 需要基础的方法 新增 add，修改update，删除delete,搜索list
   * 需要配套在 doAction中 有key为 'add','deletet'的方法
   */
  operate: PropTypes.object,

  /**
   * 列表行的操作按钮
   */
  rowOperateView: PropTypes.array,

  /***
   * 列表行操作的属性
   */
  rowOperateProps: PropTypes.object,

  /**
   * 列表操作右边区域的自定义方法
   */
  rowOperateRight: PropTypes.any,

  /**
   * 列表行的操作按钮的顺序 ['look','update', ... ]
   */
  rowOperateSort: PropTypes.array,

  /**
   * 搜索框是否打开，默认true
   */
  openPullDown: PropTypes.bool,

  //联合wizTemplate使用的属性
  /**
   * 请求方法
   */
  doAction: PropTypes.any,

  /**
   * 从接口获取的数据集
   */
  _datas: PropTypes.object,
  /**
   * loading状态
   */
  loading: PropTypes.bool, //.isRequired,
  /**
   * 是否需要过滤按钮权限
   */
  btnAccessCheck: PropTypes.bool,
  /**
   * 监控props和state的方法，等同于propsAndStateOnChange
   */
  needMonitor: PropTypes.object,
  /**
   * 是否需要查看受众的按钮
   */
  showAuth: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.array]),
  /**
   * 搜索表单默认值
   */
  params: PropTypes.object,
};

/**
 * 默认值
 */
WizTableListNew.defaultProps = {
  paging: true,
  pageFormat: {
    pageNum: "current", //页码
    pageSize: "size", //每页数量
    total: "total", //总数
    totalPages: "pages", //总页数
    //headList: 'headList',//表头数据
    sorts: "orders", //排序
    list: "records", //数据
  },
  openPullDown: true,
  rowOperateSort: [],
  btnAccessCheck: true,
  showAuth: false
};
